export default __webpack_public_path__ + "static/media/Mystic's Leggings of the Three Clarities.dcaaf31f.jpg";